import React, { useEffect } from 'react';

export const OrderSuccessStep = ({ setStep }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setStep('country');
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [setStep]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
        <div className="text-green-600 text-5xl mb-4">✅</div>
        <h2 className="text-2xl font-bold text-green-800 mb-2">Order Created Successfully!</h2>
        <p className="text-green-700">Your order has been submitted and is being processed.</p>
        <p className="text-sm text-green-600 mt-4">Returning to country selection...</p>
      </div>
    </div>
  );
};
